import { connect } from 'react-redux';

import { StepsTile, IStepsTileProps } from './StepsTile';
import { redirectPage } from '../../actions/helper';

function mapDispatchToProps(): IStepsTileProps {
  return {
    redirectPage,
  };
}

export const StepsTileContainer = connect<{}, IStepsTileProps>(null, mapDispatchToProps)(StepsTile);
